module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[115]114.788a8bf.woff2";